import ForExchangesUsers from './for-exchanges-users';

export default ForExchangesUsers;
